<!-- barra gov -->
<div
  id="barra-brasil"
  style="background: #7f7f7f; height: 20px; padding: 0 0 0 10px; display: block"
>
  <ul id="menu-barra-temp" style="list-style: none">
    <li
      style="
        display: inline;
        float: left;
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid #ededed;
      "
    >
      <a
        href="http://brasil.gov.br"
        style="font-family: sans, sans-serif; text-decoration: none; color: white"
        >Portal do Governo Brasileiro</a
      >
    </li>
  </ul>
</div>

<!-- cabecalho -->
<header class="header bg-color-primary">
  <div class="header-container color-white">
    <div class="header-title">
      <a [routerLink]="['/']" class="logo link" aria-label="irParaPrincipal">
        <span class="initials" role="separator">CNCT</span>
        <span class="logo-title-container" role="separator">
          <span class="logo-denomination" role="separator">Ministério da Educação</span>
          <h1 class="logo-main" role="separator">Catálogo Nacional de Cursos Técnicos</h1>
        </span>
      </a>
    </div>

    <div class="accessibility">
      <button
        (click)="onAltoContraste()"
        class="high-contrast-btn color-white link text-uppercase cursor-pointer"
      >
        Alto Contraste
      </button>
      <span class="separator" role="separator"></span>
      <a href="https://www.vlibras.gov.br/" class="v-libras link text-uppercase">Vlibras</a>
    </div>
  </div>
  <app-navbar></app-navbar>
</header>
